module.exports = __webpack_public_path__ + "static/media/eugene.50a22124.jpeg";